import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import {RteWorksComponent} from '../app/Component/rte-works/rte-works.component';
import { BreadcrumbComponent } from '../app/Component/subject-management/breadcrumb/breadcrumb.component';
import { DragDropComponent } from '../app/Component/drag-drop/drag-drop.component';
import { PdfViewerComponent } from '../app/Component/pdf-viewer/pdf-viewer.component';
import { SubjectManagementComponent } from '../app/Component/subject-management/subject-management.component';
import { SubjecttreeComponent } from '../app/Component/subject-management/subjecttree/subjecttree.component';
import { SubjectBreakdownAddEditComponent } from '../app/Component/subject-management/subject-breakdown-add-edit/subject-breakdown-add-edit.component';
import { TreeAddBTNComponent } from '../app/Component/Templates/tree-add-btn/tree-add-btn.component';
import { TreeAddBTNChildComponent } from '../app/Component/Templates/tree-add-btn-child/tree-add-btn-child.component';
import { TreeContentComponent } from '../app/Component/Templates/tree-content/tree-content.component';
import { SubjectDisplayOrderComponent } from '../app/Component/subject-management/subject-display-order/subject-display-order.component';
import { SubjectRelocateComponent } from '../app/Component/subject-management/subject-relocate/subject-relocate.component';
import { SubjectResourceAssignmentComponent } from '../app/Component/subject-management/subject-resource-assignment/subject-resource-assignment.component';
import { SubjectListResourceAssignmentComponent } from '../app/Component/subject-management/subject-list-resource-assignment/subject-list-resource-assignment.component';
import { SubjectRemoveResourceAssignmentComponent } from '../app/Component/subject-management/subject-remove-resource-assignment/subject-remove-resource-assignment.component';
// import { TreeAngleBtnComponent } from '../app/Component/Templates/tree-angle-btn/tree-angle-btn.component';
import { ContentManagementTreeComponent } from '../../src/app/Component/content-management/content-management-tree/content-management-tree.component';
import { QuestionMasterComponent } from './Component/question-management/question-master/question-master.component';
import { QuestionListComponent } from './Component/question-management/question-list/question-list.component';
import { QuestionSelectionTemplateComponent } from './Component/question-management/question-selection-template/question-selection-template.component';
import { QT1TextComponent } from './Component/question-management/QuestionTemplates/qt1-text/qt1-text.component';
import { Qt2TextComponent } from './Component/question-management/QuestionTemplates/qt2-text/qt2-text.component';
import { Qt3TextComponent } from './Component/question-management/QuestionTemplates/qt3-text/qt3-text.component';
import { QuestionAddEditComponent } from './Component/question-management/question-add-edit/question-add-edit.component';
import { QuillRTEComponent } from './Component/quill-rte/quill-rte.component';
import { PowerUserListComponent } from './Component/user-management/power-user-list/power-user-list.component';
import { PowerUserRegistrationComponent } from './Component/user-management/power-user-registration/power-user-registration.component';
import { AssignRolesToPowerUserComponent } from './Component/user-management/assign-roles-to-power-user/assign-roles-to-power-user.component';
import { EditPowerUserComponent } from './Component/user-management/edit-power-user/edit-power-user.component';
import { EditAssignRoleToPowerUserComponent } from './Component/user-management/edit-assign-role-to-power-user/edit-assign-role-to-power-user.component';
import { ChangePowerUserRoleStatusComponent } from './Component/user-management/change-power-user-role-status/change-power-user-role-status.component';
import { ContentStudymaterialreportsComponent } from './Component/content-management/content-studymaterialreports/content-studymaterialreports.component';
import { ContentStudyunitReportComponent } from './Component/content-management/content-studyunit-report/content-studyunit-report.component';
// import {UserSetPasswordComponent} from './Component/user-management/user-set-password/user-set-password.component';
import { UserloginComponent } from './Component/userlogin/userlogin.component';
import { AdminDashboardComponent } from './Component/admin-dashboard/admin-dashboard.component';
import { AuthGuard } from './guard/guards/auth.guard';
import { ExamAgenciesComponent } from './Component/exam-management/exam-agencies/exam-agencies.component';
import { TinymceComponent } from './Component/tinymce/tinymce.component';
import { TinyedneditorComponent } from './Component/tinyedneditor/tinyedneditor.component';
import { QuestionMonthlyReportComponent } from './Component/question-management/question-monthly-report/question-monthly-report.component';
import { QuestionStatusReportComponent } from './Component/question-management/question-status-report/question-status-report.component';
import { QuestionExternalReferencesReportComponent } from './Component/question-management/question-external-references-report/question-external-references-report.component';
import { AddEditExamAgencyComponent } from './Component/exam-management/exam-agencies/add-edit-exam-agency/add-edit-exam-agency.coponent';
import { CourseMasterComponent } from './Component/exam-management/exam-agencies/course-master-add-edit/course-master-add-edit.component';

import { QuestionMasterComponent as FAQuestionMasterComponent } from './Component/fa-management/question-master/question-master.component';
import { QuestionListComponent as FAQuestionListComponent } from './Component/fa-management/question-list/question-list.component';
import { QuestionAddEditComponent as FAQuestionAddEditComponent } from './Component/fa-management/question-add-edit/question-add-edit.component';
import { QuestionMonthlyReportComponent as FAQuestionMonthlyReportComponent } from './Component/fa-management/question-monthly-report/question-monthly-report.component';
import { QuestionStatusReportComponent as FAQuestionStatusReportComponent } from './Component/fa-management/question-status-report/question-status-report.component';
import { FlashcardExternalReferencesReportComponent } from './Component/fa-management/flashcard-external-references-report/flashcard-external-references-report.component';
import { QuestionSelectionTemplateComponent as FAQuestionSelectionTemplateComponent } from './Component/fa-management/question-selection-template/question-selection-template.component';
import { QT1TextComponent as FAQT1TextComponent } from './Component/fa-management/QuestionTemplates/qt1-text/qt1-text.component';
import { Qt2TextComponent as FAQt2TextComponent } from './Component/fa-management/QuestionTemplates/qt2-text/qt2-text.component';
import { Qt3TextComponent as FAQt3TextComponent } from './Component/fa-management/QuestionTemplates/qt3-text/qt3-text.component';
import { CourseAddEditComponent } from './Component/exam-management/exam-agencies/course-add-edit/course-edit-add.component';
import { CoursePlanAddEditComponent } from './Component/exam-management/exam-agencies/course-add-edit/course-plan-add-edit/course-plan-add-edit.component';
import { CanDeactivateGuard } from './guard/can-deactivate.guard';
import { MockExamsComponent } from './Component/exam-management/mock-exams/mock-exams.component';
import { MockExamQuestionComponent } from './Component/exam-management/exam-agencies/mock-exam-question/mock-exam-question.component';
import { AddEditMockExamQuestionComponent } from './Component/exam-management/add-edit-mock-exam-question/add-edit-mock-exam-question.component';
import { StudymaterialPratciceTestComponent } from './Component/exam-management/studymaterial-pratcice-test/studymaterial-pratcice-test.component';
import { StudyunitPracticeTestQuestionsComponent } from './Component/exam-management/studyunit-practice-test-questions/studyunit-practice-test-questions.component';
import { AddEditStudyunitPracticeQuestionComponent } from './Component/exam-management/add-edit-studyunit-practice-question/add-edit-studyunit-practice-question.component';
import { NotificationComponent } from './Component/notification-management/notification/notification.component';
import { WeeklypracticetestComponent } from './Component/exam-management/exam-agencies/weeklypracticetest/weeklypracticetest.component';
import { WeeklyPracticeTestQuestionsComponent } from './Component/exam-management/exam-agencies/weekly-practice-test-questions/weekly-practice-test-questions.component';
import { WeeklyPracticeTestQuestionSelectionComponent } from './Component/exam-management/exam-agencies/weekly-practice-test-question-selection/weekly-practice-test-question-selection.component';
const routes: Routes = [
  // {path:'rte/sample',component:RteWorksComponent},
  { path: '', component: UserloginComponent, pathMatch: 'full' },
  { path: 'draganddrop', component: DragDropComponent },
  { path: 'Content/pdfviewer', component: PdfViewerComponent },
  { path: 'subject1', component: SubjectManagementComponent },
  { path: 'subject', component: SubjecttreeComponent },
  { path: 'SubjectDisplayOrder', component: SubjectDisplayOrderComponent },
  { path: 'relocate', component: SubjectRelocateComponent },
  {
    path: 'SubjectResourceAssignmentComponent',
    component: SubjectResourceAssignmentComponent,
  },
  {
    path: 'Subject/Resources',
    component: SubjectListResourceAssignmentComponent,
  },
  {
    path: 'Content/content/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/DisplayOrder/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/Clone/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/StudyUnitReport/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/MainTopics/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  // { path: 'subject/:id', component: SubjecttreeComponent },
  {
    path: 'Content/add/edit/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/WIP/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/Approved/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/Defer/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/Rejected/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/Rework/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/Under Review/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'Content/status/Submitted/:ScreenName',
    component: ContentManagementTreeComponent,
  },
  {
    path: 'questionmaster/question/:ScreenName',
    component: QuestionMasterComponent,
  },
  { path: 'questionlist', component: QuestionListComponent },
  { path: 'questionmaster', component: QuestionMasterComponent },
  { path: 'questionlist', component: QuestionListComponent },
  { path: 'question/add', component: QuestionAddEditComponent },
  //{path:'question/body',component:QuestionBodyAddEditComponent},
  {
    path: 'questionmaster/question/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/add/edit/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/WIP/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/Approved/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/Defer/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/Rejected/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/Rework/:ScreenName',
    component: QuestionMasterComponent,
  },
  {
    path: 'questionmaster/questionstatus/Submitted/:ScreenName',
    component: QuestionMasterComponent,
  },
  { path: 'QUILLRTE', component: QuillRTEComponent },
  { path: 'User/Poweruserlist', component: PowerUserListComponent },
  { path: 'powerUserRegistration', component: PowerUserRegistrationComponent },
  {
    path: 'assignRolesToPowerUser',
    component: AssignRolesToPowerUserComponent,
  },
  { path: 'editPowerUser', component: EditPowerUserComponent },
  { path: 'editPowerUser/:id', component: EditPowerUserComponent },
  { path: 'EditPowerUserRole', component: EditAssignRoleToPowerUserComponent },
  { path: 'EditPowerUserRole/:id/:pid', component: EditAssignRoleToPowerUserComponent },
  {
    path: 'changeUserRoleStatus',
    component: ChangePowerUserRoleStatusComponent,
  },
  {
    path: 'Content/report/:ScreenName',
    component: ContentStudymaterialreportsComponent,
  },
  {
    path: 'Content/report/StudyUnit/:ScreenName',
    component: ContentStudyunitReportComponent,
  },
  // { path: 'User/Setpassword', component: UserSetPasswordComponent },
  {
    path: 'Admin/Dashboard',
    component: AdminDashboardComponent,
    canActivate: [AuthGuard],
  },
  { path: 'login', component: UserloginComponent },
  {
    path: 'Exam/StudyUnit/PracticeTest',
    component: StudymaterialPratciceTestComponent,
  },
  {
    path: 'Exam/StudyUnit/PracticeTestQuestion/:id',
    component: StudyunitPracticeTestQuestionsComponent,
  },
  {
    path: 'Exam/StudyUnit/AddEditPracticeQuestion/:id',
    component: AddEditStudyunitPracticeQuestionComponent
  },
  {
    path: 'Exam/ExamAgencies',
    component: ExamAgenciesComponent,
  },
  {
    path: 'Exam/ExamAgencies/ViewEdit',
    component: AddEditExamAgencyComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'Exam/ExamAgencies/CourseMaster/Course/ViewEdit',
    component: CourseAddEditComponent,
  },
  {
    path: 'Exam/ExamAgencies/CourseMaster/Course/CoursePlan/ViewEdit',
    component: CoursePlanAddEditComponent,
  },
  {
    path: 'Exam/ExamAgencies/CourseMaster/ViewEdit',
    component: CourseMasterComponent,
  },
  { path: 'Exam/MockExams', component: MockExamsComponent },
  { path: 'Exam/MockExamsQuestion/:id', component: MockExamQuestionComponent },
  {
    path: 'Exam/AddEditMockExamsQuestion/:id',
    component: AddEditMockExamQuestionComponent,
  },
  { path: 'Exam/WeeklyPracticeTests', component: WeeklypracticetestComponent },
  { path: 'Exam/WeeklyPracticeTestsQuestion/:id', component: WeeklyPracticeTestQuestionsComponent },
  { path: 'Exam/WeeklyPracticeTestQuestionSelection/:id', component: WeeklyPracticeTestQuestionSelectionComponent },

  {
    path:'Notifications',
    component: NotificationComponent
  },
  { path: 'TinyMCE', component: TinyedneditorComponent },
  { path: 'Question/report', component: QuestionMonthlyReportComponent },
  { path: 'Question/deferredreport', component: QuestionStatusReportComponent },
  {
    path: 'Question/validate-external-references',
    component: QuestionExternalReferencesReportComponent,
  },

  /// flash card

  {
    path: 'fa/questionmaster/question/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  { path: 'fa/questionlist', component: FAQuestionListComponent },
  { path: 'fa/questionmaster', component: FAQuestionMasterComponent },
  { path: 'fa/questionlist', component: FAQuestionListComponent },
  { path: 'fa/question/add', component: FAQuestionAddEditComponent },
  //{path:'question/body',component:QuestionBodyAddEditComponent},
  {
    path: 'fa/questionmaster/question/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/add/edit/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/WIP/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/Approved/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/Defer/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/Rejected/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/Rework/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  {
    path: 'fa/questionmaster/questionstatus/Submitted/:ScreenName',
    component: FAQuestionMasterComponent,
  },
  { path: 'fa/Question/report', component: FAQuestionMonthlyReportComponent },
  {
    path: 'fa/Question/deferredreport',
    component: FAQuestionStatusReportComponent,
  },
  {
    path: 'fa/Question/validate-external-references',
    component: FlashcardExternalReferencesReportComponent,
  },
  {
    path: 'students',
    loadChildren: () =>
      import('./Component/Students/student.module').then(
        (m) => m.StudentModule
      ),
  },
  {
    path: 'schools',
    loadChildren: () =>
      import('./Component/Schools/schools.module').then((m) => m.SchoolsModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const RoutingComponents = [
  // RteWorksComponent,
  BreadcrumbComponent,
  DragDropComponent,
  PdfViewerComponent,
  SubjectManagementComponent,
  SubjecttreeComponent,
  TreeAddBTNComponent,
  TreeAddBTNChildComponent,
  TreeContentComponent,
  SubjectBreakdownAddEditComponent,
  SubjectDisplayOrderComponent,
  SubjectRelocateComponent,
  SubjectResourceAssignmentComponent,
  SubjectListResourceAssignmentComponent,
  SubjectRemoveResourceAssignmentComponent,
  ContentManagementTreeComponent,
  QuestionMasterComponent,
  QuestionListComponent,
  QuestionSelectionTemplateComponent,
  Qt3TextComponent,
  Qt2TextComponent,
  QT1TextComponent,
  QuestionAddEditComponent,
  QuillRTEComponent,
  PowerUserListComponent,
  PowerUserRegistrationComponent,
  AssignRolesToPowerUserComponent,
  EditPowerUserComponent,
  EditAssignRoleToPowerUserComponent,
  ChangePowerUserRoleStatusComponent,
  ContentStudymaterialreportsComponent,
  ContentStudyunitReportComponent,
  AdminDashboardComponent,
  ExamAgenciesComponent,
  TinymceComponent,
  TinyedneditorComponent,
  QuestionMonthlyReportComponent,
  QuestionStatusReportComponent,
  QuestionExternalReferencesReportComponent,
  AddEditExamAgencyComponent,
  CourseMasterComponent,
  // TreeAngleBtnComponent
  // Flash Card
  FAQuestionMasterComponent,
  FAQuestionListComponent,
  FAQuestionMonthlyReportComponent,
  FAQuestionStatusReportComponent,
  FlashcardExternalReferencesReportComponent,
  FAQuestionAddEditComponent,
  FAQuestionSelectionTemplateComponent,
  FAQT1TextComponent,
  FAQt2TextComponent,
  FAQt3TextComponent,
  CourseAddEditComponent,
  CoursePlanAddEditComponent,
];
